export default __webpack_public_path__ + "static/media/CookiesCharcoal.34da999a.png";